import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Card from "../components/card"
import PageTitle from "../components/pageTitle"
import SectionTitle from "../components/sectionTitle"
import Container from "../components/container"
import Sidebar from "../components/sidebar"
import Pagination from "../components/pagination"
import CasesFilter from "../components/casesFilter"

const CasesTemplate = ({ pageContext, data, location }) => {
  const posts = data.allMarkdownRemark.nodes

  return (
    <Layout location={location}>
      <Seo
        title={`${
          pageContext.currentPage !== 1
            ? `${pageContext.currentPage}ページ目｜`
            : ``
        }${pageContext.metaData.title}の事例一覧`}
        description={`${pageContext.metaData.title}の事例一覧です。開発・活用事例を紹介しています。`}
      />
      <PageTitle
        title={pageContext.metaData.title}
        description={`${pageContext.metaData.title}の事例一覧です。開発・活用事例を紹介しています。`}
      />
      <Container className="lg:flex justify-between mt-6 lg:mt-12 mb-6 lg:mb-12">
        <div className="lg:w-2/3">
          <SectionTitle title="記事一覧" bgText="Articles" className="mb-6" />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-7">
            {posts.map(post => (
              <Card
                post={post}
                size="m"
                key={`${pageContext.tag}-${post.id}`}
              />
            ))}
          </div>
          <div className="pt-14">
            <Pagination
              numPages={pageContext.numPages}
              currentPage={pageContext.currentPage}
              pageLimit={5}
              pagingPath={`/cases-${pageContext.metaData.name}/`}
              hasRootUrl={true}
            />
          </div>
        </div>
        <div className="lg:w-1/4">
          <Sidebar>
            <CasesFilter selected={pageContext.metaData.name} />
          </Sidebar>
        </div>
      </Container>
    </Layout>
  )
}

export default CasesTemplate

export const pageQuery = graphql`
  query ($tag: String, $skip: Int!, $limit: Int!, $solution: String) {
    allMarkdownRemark(
      limit: $limit
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        frontmatter: { tags: { in: [$tag] }, solution: { in: [$solution] } }
        fields: { meta: { draft: { eq: false } } }
      }
      skip: $skip
    ) {
      totalCount
      nodes {
        fields {
          meta {
            slug
          }
        }
        frontmatter {
          date(formatString: "YYYY.MM.DD")
          title
          description
          tags
          cover {
            childImageSharp {
              gatsbyImageData(width: 800, formats: AUTO)
            }
          }
        }
        id
      }
    }
  }
`
